function findCity(city){
    $("input#lat").val("");
    $("input#lng").val("");
    geocodeAddress(city);
    $('#map-wrap').show();
    $("#address").val("");
}
function geocodeAddress(address) {
    console.log(address);
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': address}, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            initMap(results[0].geometry.location, 12)
        } else {
            alert('Geocode was not successful for the following reason: ' + status);
        }
        console.log(results)
    });
}


function initMap(location, zoom) {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: location,
        zoom: zoom
    });
    var input = /** @type {!HTMLInputElement} */(
        document.getElementById('address')
    );
    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);

    var service = new google.maps.places.PlacesService(map);

    var infowindow = new google.maps.InfoWindow();
    var marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29),
        position: location
    });

    marker.setPosition(location);
    marker.setVisible(true);

    autocomplete.addListener('place_changed', function() {
        setPlace()
    });
    google.maps.event.addListener(map, 'click', function(event) {
        geocodeLatLng(event.latLng);
    });
    function geocodeLatLng(latlng) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'latLng': latlng
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    geocoder.geocode({'address': results[0].formatted_address}, function(results, status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                            map.setCenter(results[0].geometry.location);
                            marker.setPosition(results[0].geometry.location);
                            infowindow.setContent(results[0].formatted_address);
                            infowindow.open(map, marker);
                            document.getElementById('address').value = results[0].formatted_address;
                            $("input#lat").val(results[0].geometry.location.lat());
                            $("input#lng").val(results[0].geometry.location.lng());

                            service.textSearch({query: results[0].formatted_address}, function (results, status) {
                                if (status == google.maps.places.PlacesServiceStatus.OK &&
                                    document.getElementById('address_short').value.trim() == "")
                                {
                                    document.getElementById('address_short').value = results[0].name;
                                }
                            });
                        } else {
                            window.alert("Мы не смогли автоматически найти адрес");
                        }
                    })
                }
            }
        });
    }

    function setPlace(){
        infowindow.close();
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        document.getElementById('address').value = place.formatted_address;
        if (document.getElementById('address_short').value.trim() == "") {
            document.getElementById('address_short').value = place.name;
        }
        if (!place.geometry) {
            window.alert("Мы не смогли автоматически найти адрес по вашему запросу. Проверьте данные и попробуйте ещё раз");
            return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);  // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
        }

        infowindow.setContent(place.adr_address);
        infowindow.open(map, marker);
    }
    // Autocomplete.

    autocomplete.setTypes(['address']);
}
var markersArray = [];
function placeMarker(location) {
    // first remove all markers if there are any
    deleteOverlays();

    var marker = new google.maps.Marker({
        position: location,
        map: map
    });

    // add marker in markers array
    markersArray.push(marker);

    //map.setCenter(location);
}

// Deletes all markers in the array by removing references to them
function deleteOverlays() {
    if (markersArray) {
        for (i in markersArray) {
            markersArray[i].setMap(null);
        }
        markersArray.length = 0;
    }
}